import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useGetMyNewNotificationsQuery, useGetMyNotificationsQuery, useGetMyUnreadNotificationsQuery, useSetNewNotificationToReadMutation } from '../slices/notificationsApiSlice';

/** 横幅轮询：有新未读才弹；未读计数可更慢 */
const NEW_LIST_POLL_MS = 10000;
const UNREAD_COUNT_POLL_MS = 60000;

export const NotificationContext = createContext({ products: [] });

const NotificationProvider = ({ children }) => {
	const [pageVisible, setPageVisible] = useState(() => (typeof document === 'undefined' ? true : document.visibilityState !== 'hidden'));

	useEffect(() => {
		const onVisibility = () => setPageVisible(document.visibilityState !== 'hidden');
		document.addEventListener('visibilitychange', onVisibility);
		return () => document.removeEventListener('visibilitychange', onVisibility);
	}, []);

	const { data: newUnreadNotifications = [], isLoading: loadingNotify, isSuccess: notificationsReady, refetch } = useGetMyNewNotificationsQuery(undefined, {
		pollingInterval: pageVisible ? NEW_LIST_POLL_MS : 0,
	});
	const { data: unreadNotificationsCount = [] } = useGetMyUnreadNotificationsQuery(undefined, {
		pollingInterval: pageVisible ? UNREAD_COUNT_POLL_MS : 0,
	});
	const [setToRead] = useSetNewNotificationToReadMutation();
	const { data: myNotifications = [] } = useGetMyNotificationsQuery();

	const value = useMemo(
		() => ({
			setToRead,
			newUnreadNotifications,
			unreadNotificationsCount,
			myNotifications,
			loadingNotify,
			notificationsReady,
			refetch,
		}),
		[setToRead, newUnreadNotifications, unreadNotificationsCount, myNotifications, loadingNotify, notificationsReady, refetch],
	);

	return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};

NotificationProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const useNotificationContext = () => useContext(NotificationContext);

export default NotificationProvider;
